import { getStudentData, setLocalStorage } from "../../helper/localStorage";
import { createShuffledArray } from "../../helper/nextQues";
import testData from "../../pages/afterLogin/mapprTracker/testData.json";
import reverseData from "../../pages/afterLogin/mapprTracker/reverseData.json";

export const startDigitMemorySpanTest = (
  test_id,
  gradeId,
  dispatchLaunchTest,
  dispatchHelper
) => {

  dispatchLaunchTest({
    type: "LOADER",
  });

  testData.data[0].que = [];

  for (let i = 3; i <= 10; i++) {
    const questionArray = createShuffledArray(i);
    testData.data[0].que.push({
      id: i,
      test_id: test_id,
      section_id: "60",
      choice_type: "",
      que_hint: "",
      que_title1: "Numbers are presented in below box.\nRemember the sequence of numbers",
      que_title1_type: "text",
      que_title2: questionArray,
      link1: "",
      link1_type: "",
      link2: "",
      link2_type: "",
      link1_ssml: "",
      link1_ssml_type: "",
      link2_ssml: "",
      link2_ssml_type: "audio",
      parent_quetitle: "",
      parent_link: "",
      parent_link_type: "",
      type_flag: "",
      grade: gradeId,
      difficulty_level: "1",
      choice_1: "",
      choice_2: "",
      choice_3: "",
      choice_4: "",
      choice_5: "",
      choice_6: "",
      correct_choice: "",
      correct_text: questionArray.toString(),
      resp_time: "30",
      active: "Y",
      created_date: "0000-00-00 00:00:00",
      created_by: "1",
      test_format: "digit_span",
      section_name: "DIGIT MEMORY SPAN",
      intro1:
        " Tapping before the stars appears will be considered negative. \n  <li>You have 20 attempts to record your fastest response time. </li>\n  <li>Total Test Duration – 4 minutes</li>\n  <li>Time to answer each question/attempt – 10 seconds</li>\n  <li>Respond as fast as you can</li>\n</ol>",
      intro2:
        "Your test will end if –<br>\n<ol>\n  <li>You minimize the app or go away from the test screen.</li>\n</ol>\n<br>",
      intro3:
        "Tap to start. Remember the position where the stars appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info: "Tap to start. Remember the position where the star appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info_audio: "digit_span",
      info_video: "digit_span_video",
      replay: "Y",
      score_rule: "Rule1",
      match_type: "exact",
      match_order: "Y",
      score_count: "single",
      match_hint: "N",
      custom_rule: "N",
      letter_count: "0",
    });
  }

  dispatchLaunchTest({ type: "RUNNING_TEST_DATA", payload: testData });
  console.log(
    "%claunchtest!",
    "color:red;font-family:system-ui;font-size:2rem;font-weight:bold",
    testData
  );
  const isCustomId = testData.data[0].test_format === "tap_letter";
  const FNMix = testData.data[0].test_format === "visual_facename_mix";

  const getTestId = () => {
    return isCustomId
      ? 1
      : FNMix
      ? "11862" // first id for FNMix test
      : testData.data[0].que[0].id; // custom id for CPT test
  };
  dispatchHelper({
    type: "RUNNING_QUES_ID",
    payload: getTestId(),
  });
  setLocalStorage("RESERVE_TEST_DATA", testData);

  dispatchLaunchTest({ type: "RESERVE_TEST_ID", payload: getTestId() });
};

export const startDigitReverseSpanTest = (
  test_id,
  gradeId,
  dispatchLaunchTest,
  dispatchHelper
) => {

  dispatchLaunchTest({
    type: "LOADER",
  });

  reverseData.data[0].que = [];

  for (let i = 3; i <= 10; i++) {
    const questionArray = createShuffledArray(i);
    console.log(questionArray);
    reverseData.data[0].que.push({
      id: 11833 + i,
      test_id: test_id,
      section_id: "60",
      choice_type: "",
      que_hint: "",
      que_title1: "Numbers are presented in below box.\nRemember the sequence of numbers",
      que_title1_type: "text",
      que_title2: [...questionArray],
      link1: "",
      link1_type: "",
      link2: "",
      link2_type: "",
      link1_ssml: "",
      link1_ssml_type: "",
      link2_ssml: "",
      link2_ssml_type: "audio",
      parent_quetitle: "",
      parent_link: "",
      parent_link_type: "",
      type_flag: "",
      grade: gradeId,
      difficulty_level: "1",
      choice_1: "",
      choice_2: "",
      choice_3: "",
      choice_4: "",
      choice_5: "",
      choice_6: "",
      correct_choice: "",
      correct_text: [...questionArray].reverse().toString(),
      resp_time: "30",
      active: "Y",
      created_date: "0000-00-00 00:00:00",
      created_by: "1",
      test_format: "digit_reverse_span",
      section_name: "DIGIT REVERSE SPAN",
      intro1:
        " Tapping before the stars appears will be considered negative. \n  <li>You have 20 attempts to record your fastest response time. </li>\n  <li>Total Test Duration – 4 minutes</li>\n  <li>Time to answer each question/attempt – 10 seconds</li>\n  <li>Respond as fast as you can</li>\n</ol>",
      intro2:
        "Your test will end if –<br>\n<ol>\n  <li>You minimize the app or go away from the test screen.</li>\n</ol>\n<br>",
      intro3:
        "Tap to start. Remember the position where the stars appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info: "Tap to start. Remember the position where the star appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info_audio: "digit_reverse_span",
      info_video: "digit_reverse_span_video",
      replay: "Y",
      score_rule: "Rule1",
      match_type: "exact",
      match_order: "Y",
      score_count: "single",
      match_hint: "N",
      custom_rule: "N",
      letter_count: "0",
    });
    console.log(questionArray.toString());
  }

  dispatchLaunchTest({ type: "RUNNING_TEST_DATA", payload: reverseData });
  console.log(
    "%claunchtest!",
    "color:red;font-family:system-ui;font-size:2rem;font-weight:bold",
    reverseData
  );
  const isCustomId = reverseData.data[0].test_format === "tap_letter";
  const FNMix = reverseData.data[0].test_format === "visual_facename_mix";

  const getTestId = () => {
    return isCustomId
      ? 1
      : FNMix
      ? "11862" // first id for FNMix test
      : reverseData.data[0].que[0].id; // custom id for CPT test
  };
  dispatchHelper({
    type: "RUNNING_QUES_ID",
    payload: getTestId(),
  });
  setLocalStorage("RESERVE_TEST_DATA", reverseData);

  dispatchLaunchTest({ type: "RESERVE_TEST_ID", payload: getTestId() });
};
